/**
 * One place that decides how a list endpoint is cached.
 *
 * This exists because of a real bug, not tidiness: pages were caching the same endpoint under
 * hand-written keys (`['tax-groups']`, `['floor-zones']`) while the shared table component cached
 * it as `['crud', path]`. Saving through one path invalidated a cache entry the other page was
 * not reading, so the user got a green "Saved" over a table that never changed — the worst class
 * of UI bug, because it teaches people to distrust a system that is actually working.
 *
 * Derive every key from the request. Then two callers of one endpoint cannot disagree.
 */
export const listKey = (path: string, query?: Record<string, unknown>) =>
  query && Object.keys(query).length > 0 ? (['list', path, query] as const) : (['list', path] as const);

export const detailKey = (path: string, id: string) => ['detail', path, id] as const;
